import * as ng from 'angular';

import { ApiHelperService } from '../../shared';

export class DashboardApiService {
   static $inject = ['apiHelper'];

   constructor(private apiHelper:ApiHelperService) { }

   getEvents(campaignId, days) {
      var url = 'dashboard/' + campaignId;
      if (days) url += '?days=' + days;
      return this.apiHelper.get(url);
   }
}

ng.module('e360').service('dashboardApi', DashboardApiService);

export interface DashboardEvent extends Event {
   type:'completed-empty'|'upcoming'|'current';
   participantCount:number;
   preRegCount:number;
}
